import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center h-100" }
const _hoisted_2 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "col-2 pretty_button m-0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.decrementValue()))
      }, "-"),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.modelValue) + " " + _toDisplayString(_ctx.declOfNum(_ctx.modelValue,_ctx.labels)), 1),
      _createElementVNode("button", {
        class: "col-2 pretty_button m-0",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.incrementValue()))
      }, "+")
    ])
  ]))
}